export const Manifesto = () => {
  return (
    <section
      id="academy"
      data-testid="manifesto-section"
      className="bg-[#fafaf7] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="rule-yellow" />
              <span className="eyebrow">Manifesto</span>
            </div>
            <p className="text-[15px] leading-relaxed text-[#3a3a3a] max-w-sm">
              Uma posição institucional sobre o que mudou no mercado da beleza.
              E sobre o tipo de profissional que esse novo mercado pede.
            </p>
          </div>

          <div className="lg:col-span-8 reveal">
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.08] tracking-tight text-[#0a0a0a]">
              O mercado da beleza aprendeu a gerar movimento.
              <br />
              <span className="italic">
                Agora precisa aprender a transformar movimento em crescimento.
              </span>
            </h2>

            <div className="mt-14 md:mt-16 max-w-3xl text-[1.05rem] md:text-lg leading-[1.7] text-[#1f1f1f] space-y-7">
              <p>
                A indicação continua sendo um dos ativos mais valiosos da
                beleza.
              </p>
              <div className="space-y-1.5">
                <p>Talento também.</p>
                <p>Agenda cheia também.</p>
              </div>
              <p>
                Mas nenhum desses ativos sustenta crescimento sozinho quando
                o comportamento da cliente mudou.
              </p>

              <p className="pt-2">
                Hoje, a cliente é disputada antes de entrar no salão.
              </p>
              <p>
                No sofá de casa, ela é impactada por ofertas, aplicativos,
                marketplaces, influenciadores, entretenimento e algoritmos
                que sabem ler desejo, atenção e momento de compra.
              </p>
              <p>
                Enquanto isso, muitos profissionais ainda olham apenas para
                a agenda do dia.
              </p>

              <div className="pt-4 border-t border-[#0a0a0a]/12">
                <p className="font-display text-xl md:text-2xl leading-snug text-[#0a0a0a] tracking-tight mb-5">
                  O novo crescimento da beleza exige mais consciência de
                  mercado.
                </p>
                <ul className="space-y-1.5 text-[1.05rem] md:text-lg leading-snug text-[#1f1f1f]">
                  <li>Exige posicionamento.</li>
                  <li>Exige leitura de agenda.</li>
                  <li>
                    Exige entender frequência, retorno, ausência, ticket,
                    desejo, medo, intenção e comportamento.
                  </li>
                </ul>
              </div>

              <p className="pt-2">
                Porque cada atendimento deixa uma informação.
              </p>
              <p>
                E cada informação ignorada pode virar uma oportunidade
                perdida.
              </p>

              <p className="pt-6 font-display text-xl md:text-2xl leading-snug text-[#0a0a0a] tracking-tight">
                A Oasys Academy existe para formar esse novo profissional:
                técnico, consciente, estratégico e capaz de{" "}
                <em className="italic font-normal text-[#7a5a00]">
                  transformar atendimento em inteligência de crescimento
                </em>
                .
              </p>
            </div>

            <div className="mt-16 flex flex-col md:flex-row gap-8 md:gap-12">
              {[
                {
                  k: "Menos coach.",
                  v: "Mais método.",
                },
                {
                  k: "Menos palco.",
                  v: "Mais leitura de mercado.",
                },
                {
                  k: "Menos promessa.",
                  v: "Mais inteligência aplicada.",
                },
              ].map((item) => (
                <div
                  key={item.k}
                  className="flex-1 border-t border-[#0a0a0a]/15 pt-5"
                >
                  <p className="font-display text-xl md:text-2xl text-[#0a0a0a]">
                    {item.k}
                  </p>
                  <p className="font-display italic text-xl md:text-2xl text-[#7a5a00] mt-1">
                    {item.v}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
